/**
 * OneHome exact variant gallery rebuild for Kalles 4.3.5 — v3.0.
 *
 * The previous patches only hid Flickity cells. Kalles kept the old thumbnail
 * HTML, which caused a correct large image but stale thumbnails. This version
 * rebuilds the gallery itself with only the exact variant's slides and lets
 * Kalles recreate Flickity and its thumbnail rail from that exact DOM.
 */
(function () {
  'use strict';

  if (window.OneHomeVariantMediaRebuildV30Loaded) return;
  window.OneHomeVariantMediaRebuildV30Loaded = true;

  var ROOT_SELECTOR = '[data-onehome-variant-media-root]';
  var MAP_SELECTOR = '[data-onehome-variant-image-map]';
  var GALLERY_SELECTOR = '[data-main-media][data-t4s-thumb-true]';
  var SLIDE_SELECTOR = '[data-main-slide]';
  var READY_CLASS = 'onehome-variant-media-ready';
  var PENDING_CLASS = 'onehome-variant-media-pending';
  var UPDATING_CLASS = 'onehome-variant-media-updating';

  function normalizeId(value) {
    var text = String(value == null ? '' : value).trim();
    if (!text) return '';
    var parts = text.split('/');
    return parts[parts.length - 1];
  }

  function normalizeUrl(value) {
    var text = String(value == null ? '' : value).trim();
    if (!text) return '';
    return text
      .replace(/^https?:/i, '')
      .split('?')[0]
      .replace(/\/$/, '')
      .toLowerCase();
  }

  function parseJsonMap(root) {
    var node = root.querySelector(MAP_SELECTOR);
    if (!node) return [];

    try {
      var value = JSON.parse(node.textContent || '[]');
      if (typeof value === 'string') value = JSON.parse(value);

      if (Array.isArray(value)) return value;
      if (value && Array.isArray(value.variants)) return value.variants;
      if (value && Array.isArray(value.entries)) return value.entries;

      if (value && typeof value === 'object') {
        return Object.keys(value)
          .map(function (key) { return value[key]; })
          .filter(function (entry) { return entry && typeof entry === 'object'; });
      }
    } catch (error) {
      console.error('[OneHome v3.0] custom.variant_image_map ist kein gültiges JSON.', error);
    }

    return [];
  }

  function variantIdentity(variant) {
    if (variant && typeof variant === 'object') {
      return {
        id: normalizeId(variant.id || variant.variantId),
        sku: String(variant.sku || '').trim(),
        featuredMediaId: normalizeId(
          (variant.featured_media && variant.featured_media.id) ||
          (variant.featuredMedia && variant.featuredMedia.id) ||
          variant.mediaId
        )
      };
    }

    return { id: normalizeId(variant), sku: '', featuredMediaId: '' };
  }

  function findEntry(map, variant) {
    var identity = variantIdentity(variant);
    var i;

    for (i = 0; i < map.length; i += 1) {
      var entry = map[i] || {};
      if (identity.id && normalizeId(entry.variantId || entry.id) === identity.id) return entry;
    }

    if (identity.sku) {
      for (i = 0; i < map.length; i += 1) {
        var skuEntry = map[i] || {};
        if (String(skuEntry.sku || '').trim() === identity.sku) return skuEntry;
      }
    }

    return null;
  }

  function gallerySliderId(gallery) {
    var raw = gallery.getAttribute('data-flickityt4s-js') || '{}';
    try {
      return String((JSON.parse(raw) || {}).t4sid || '');
    } catch (error) {
      var match = raw.match(/"t4sid"\s*:\s*"([^"]+)"/);
      return match ? match[1] : '';
    }
  }

  function captureGallery(gallery) {
    var state = {
      gallery: gallery,
      originalClassName: gallery.className,
      originalStyle: gallery.getAttribute('style'),
      sliderId: gallerySliderId(gallery),
      templatesById: Object.create(null),
      mediaIdByUrl: Object.create(null),
      allMediaIds: [],
      staticNodes: []
    };

    Array.prototype.slice.call(gallery.childNodes).forEach(function (node) {
      if (node.nodeType === 1 && node.matches(SLIDE_SELECTOR)) {
        var id = normalizeId(node.getAttribute('data-media-id'));
        if (!id || state.templatesById[id]) return;

        var clone = node.cloneNode(true);
        state.templatesById[id] = clone;
        state.allMediaIds.push(id);

        var image = clone.querySelector('img');
        if (image) {
          [
            image.getAttribute('data-master'),
            image.getAttribute('data-src'),
            image.getAttribute('src')
          ].forEach(function (url) {
            var normalized = normalizeUrl(url);
            if (normalized) state.mediaIdByUrl[normalized] = id;
          });
        }
      } else {
        state.staticNodes.push(node.cloneNode(true));
      }
    });

    return state;
  }

  function entryImages(entry) {
    if (!entry) return [];
    if (Array.isArray(entry.images)) return entry.images;
    if (Array.isArray(entry.media)) return entry.media;
    if (Array.isArray(entry.imageUrls)) return entry.imageUrls;
    if (Array.isArray(entry.urls)) return entry.urls;
    return [];
  }

  function mediaIdsForEntry(entry, state, variant) {
    var ids = [];
    var seen = Object.create(null);

    function addId(rawId) {
      var id = normalizeId(rawId);
      if (!id || seen[id] || !state.templatesById[id]) return false;
      seen[id] = true;
      ids.push(id);
      return true;
    }

    function addUrl(rawUrl) {
      var url = normalizeUrl(rawUrl);
      if (!url || !state.mediaIdByUrl[url]) return false;
      return addId(state.mediaIdByUrl[url]);
    }

    entryImages(entry).forEach(function (record) {
      if (record && typeof record === 'object') {
        var added = addId(record.mediaId || record.media_id || record.id || record.gid);
        if (!added) {
          addUrl(
            record.url || record.src || record.originalSource ||
            record.original_source || record.imageUrl
          );
        }
      } else if (typeof record === 'string') {
        if (!addId(record)) addUrl(record);
      }
    });

    if (entry && Array.isArray(entry.mediaIds)) entry.mediaIds.forEach(addId);

    var identity = variantIdentity(variant);
    if (!ids.length && identity.featuredMediaId) addId(identity.featuredMediaId);

    return ids.length ? ids : state.allMediaIds.slice();
  }

  function restoreGalleryShell(state) {
    var gallery = state.gallery;
    gallery.className = state.originalClassName;
    if (state.originalStyle == null) gallery.removeAttribute('style');
    else gallery.setAttribute('style', state.originalStyle);
    gallery.removeAttribute('tabindex');
  }

  function replaceGalleryChildren(state, mediaIds) {
    var gallery = state.gallery;
    restoreGalleryShell(state);

    while (gallery.firstChild) gallery.removeChild(gallery.firstChild);

    mediaIds.forEach(function (id) {
      var template = state.templatesById[id];
      if (template) gallery.appendChild(template.cloneNode(true));
    });

    state.staticNodes.forEach(function (node) {
      gallery.appendChild(node.cloneNode(true));
    });
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value || '').replace(/([^a-zA-Z0-9_-])/g, '\\$1');
  }

  function navElements(root, state) {
    var selector = state.sliderId
      ? '.carousel__nav--' + cssEscape(state.sliderId)
      : '.t4s-carousel__nav';

    return {
      nav: root.querySelector(selector) || document.querySelector(selector),
      prev: state.sliderId
        ? document.querySelector('[data-thumb-btn__prev="' + cssEscape(state.sliderId) + '"]')
        : null,
      next: state.sliderId
        ? document.querySelector('[data-thumb-btn__next="' + cssEscape(state.sliderId) + '"]')
        : null
    };
  }

  function destroyCarousel(root, state) {
    var gallery = state.gallery;
    var jq = window.jQuery_T4NT || window.jQuery;
    var wrapper = gallery.flickityt4s;

    try {
      if (wrapper && typeof wrapper.destroy === 'function') {
        wrapper.destroy();
      } else if (jq && jq(gallery).data('flickityt4s')) {
        jq(gallery).flickityt4s('destroy');
      }
    } catch (error) {
      console.warn('[OneHome v3.0] Altes Karussell konnte nicht vollständig zerstört werden.', error);
    }

    if (jq) {
      jq(gallery).off();
      var parts = navElements(root, state);
      if (parts.nav) jq(parts.nav).off().empty().removeClass('is--nav-ready');
      if (parts.prev) jq(parts.prev).off();
      if (parts.next) jq(parts.next).off();
    }

    try { delete gallery.flickityt4s; }
    catch (error) { gallery.flickityt4s = null; }
  }

  function carouselReady(root, state) {
    if (!state.gallery.classList.contains('flickityt4s-enabled')) return false;
    var parts = navElements(root, state);
    return !parts.nav || parts.nav.classList.contains('is--nav-ready');
  }

  function ensureCarousel(root, state, callback, startedAt) {
    startedAt = startedAt || Date.now();

    if (carouselReady(root, state)) {
      callback();
      return;
    }

    if (window.T4SThemeSP && typeof window.T4SThemeSP.Carousel === 'function') {
      try {
        if (!state.gallery.flickityt4s && !state.gallery.classList.contains('flickityt4s-enabled')) {
          state.gallery.flickityt4s = new window.T4SThemeSP.Carousel(state.gallery);
        }
      } catch (error) {
        console.warn('[OneHome v3.0] Kalles-Initialisierung wird erneut versucht.', error);
      }
    }

    if (Date.now() - startedAt > 2500) {
      callback();
      return;
    }

    window.setTimeout(function () {
      ensureCarousel(root, state, callback, startedAt);
    }, 25);
  }

  function reveal(root) {
    root.classList.remove(PENDING_CLASS, UPDATING_CLASS);
    root.classList.add(READY_CLASS);
  }

  function rebuildForVariant(root, variant, initial) {
    var states = root.__onehomeGalleryStates || [];
    var map = root.__onehomeVariantImageMap || [];
    var entry = findEntry(map, variant);
    var generation = (root.__onehomeGalleryGeneration || 0) + 1;
    root.__onehomeGalleryGeneration = generation;

    if (!states.length || !entry) {
      reveal(root);
      return;
    }

    if (!initial) {
      root.classList.add(UPDATING_CLASS);
      root.classList.remove(READY_CLASS);
    }

    var remaining = states.length;

    states.forEach(function (state) {
      var mediaIds = mediaIdsForEntry(entry, state, variant);

      if (!initial) destroyCarousel(root, state);
      replaceGalleryChildren(state, mediaIds);

      ensureCarousel(root, state, function () {
        if (root.__onehomeGalleryGeneration !== generation) return;

        var jq = window.jQuery_T4NT || window.jQuery;
        if (jq && state.gallery.classList.contains('flickityt4s-enabled')) {
          try { jq(state.gallery).flickityt4s('select', 0, false, true); } catch (error) {}
          try { jq(state.gallery).flickityt4s('resize'); } catch (error) {}
        }

        remaining -= 1;
        if (remaining <= 0) reveal(root);
      });
    });
  }

  function initializeRoot(root) {
    if (!root || root.__onehomeVariantMediaPrepared) return;
    root.__onehomeVariantMediaPrepared = true;

    var map = parseJsonMap(root);
    var galleries = Array.prototype.slice.call(root.querySelectorAll(GALLERY_SELECTOR));

    if (!map.length || !galleries.length) {
      reveal(root);
      return;
    }

    root.__onehomeVariantImageMap = map;
    root.__onehomeGalleryStates = galleries.map(captureGallery);

    rebuildForVariant(
      root,
      { id: root.getAttribute('data-onehome-initial-variant-id') },
      true
    );
  }

  function rootFromEvent(event) {
    var target = event && event.target && event.target.nodeType === 1 ? event.target : null;
    if (target) {
      if (target.matches(ROOT_SELECTOR)) return target;
      var closest = target.closest(ROOT_SELECTOR);
      if (closest) return closest;
    }
    return document.querySelector(ROOT_SELECTOR);
  }

  function scheduleVariant(root, variant) {
    if (!root) return;
    window.clearTimeout(root.__onehomeVariantTimer);
    root.__onehomeVariantTimer = window.setTimeout(function () {
      rebuildForVariant(root, variant, false);
    }, 25);
  }

  function bindVariantEvents(startedAt) {
    startedAt = startedAt || Date.now();
    var jq = window.jQuery_T4NT || window.jQuery;

    if (jq) {
      jq(document)
        .off('variant:changed.onehomeGalleryV30')
        .on('variant:changed.onehomeGalleryV30', function (event) {
          scheduleVariant(rootFromEvent(event), event.currentVariant || null);
        });
      return;
    }

    if (Date.now() - startedAt < 3000) {
      window.setTimeout(function () { bindVariantEvents(startedAt); }, 30);
    }
  }

  function initializeAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var roots = scope.matches && scope.matches(ROOT_SELECTOR)
      ? [scope]
      : scope.querySelectorAll(ROOT_SELECTOR);
    Array.prototype.forEach.call(roots, initializeRoot);
  }

  /* Loaded without defer at the end of main-product.liquid. The section DOM is
     available, while Kalles' deferred global script normally has not initialized
     Flickity. This lets us remove unrelated slides before the first layout. */
  initializeAll(document);
  bindVariantEvents();

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target || document);
  });

  if (window.MutationObserver && document.documentElement) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(ROOT_SELECTOR)) initializeRoot(node);
          else if (node.querySelectorAll) initializeAll(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
